
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EntityEspeciesCertificablesService } from './entity-especies-certificables.service';
import {
  EntityEspeciesCertificablesAddFailure,
  EntityEspeciesCertificablesAddRequest,
  EntityEspeciesCertificablesAddSuccess,
  EntityEspeciesCertificablesDeleteFailure,
  EntityEspeciesCertificablesDeleteRequest,
  EntityEspeciesCertificablesDeleteSuccess,
  EntityEspeciesCertificablesLoadFailure,
  EntityEspeciesCertificablesLoadRequest,
  EntityEspeciesCertificablesLoadSuccess,
  EntityEspeciesCertificablesUpdateFailure,
  EntityEspeciesCertificablesUpdateRequest,
  EntityEspeciesCertificablesUpdateSuccess
} from './entity-especies-certificables.actions';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { NotificationService } from '../../../core/core.module';

@Injectable()
export class EntityEspeciesCertificablesEffects {
  constructor(
    private actions$: Actions,
    private EntityEspeciesCertificablesService: EntityEspeciesCertificablesService,
    private notificationService: NotificationService
  ) {}

  loadRequest = createEffect(() =>
    this.actions$.pipe(
      ofType(EntityEspeciesCertificablesLoadRequest),
      mergeMap(() =>
        this.EntityEspeciesCertificablesService.getAll().pipe(
          map((items) => EntityEspeciesCertificablesLoadSuccess({ items })),
          catchError((error) => of(EntityEspeciesCertificablesLoadFailure({ error })))
        )
      )
    )
  );

  addRequest = createEffect(() =>
    this.actions$.pipe(
      ofType(EntityEspeciesCertificablesAddRequest),
      mergeMap((action) =>
        this.EntityEspeciesCertificablesService.add(action.item).pipe(
          map((item) => EntityEspeciesCertificablesAddSuccess({ item })),
          catchError((error) => of(EntityEspeciesCertificablesAddFailure({ error })))
        )
      )
    )
  );

  updateRequest = createEffect(() =>
    this.actions$.pipe(
      ofType(EntityEspeciesCertificablesUpdateRequest),
      mergeMap((action) =>
        this.EntityEspeciesCertificablesService.update(action.item).pipe(
          map((item) => EntityEspeciesCertificablesUpdateSuccess({ item: action.item })),
          catchError((error) => of(EntityEspeciesCertificablesUpdateFailure({ error })))
        )
      )
    )
  );

  deleteRequest = createEffect(() =>
    this.actions$.pipe(
      ofType(EntityEspeciesCertificablesDeleteRequest),
      mergeMap((action) =>
        this.EntityEspeciesCertificablesService.delete(action.item).pipe(
          map((item) => {
            this.notificationService.success(
              'EntityEspeciesCertificables eliminado correctamente.'
            );
            return EntityEspeciesCertificablesDeleteSuccess({ item: action.item });
          }),
          catchError((error) => of(EntityEspeciesCertificablesDeleteFailure({ error })))
        )
      )
    )
  );

  addSuccess = createEffect(
    () =>
      this.actions$.pipe(
        ofType(EntityEspeciesCertificablesAddSuccess),
        tap(() =>
          this.notificationService.success(
            'EntityEspeciesCertificables registrado correctamente.'
          )
        )
      ),
    { dispatch: false }
  );

  addFailure = createEffect(
    () =>
      this.actions$.pipe(
        ofType(EntityEspeciesCertificablesAddFailure),
        tap(() =>
          this.notificationService.error('Error al registrar EntityEspeciesCertificables.')
        )
      ),
    { dispatch: false }
  );

  updateSuccess = createEffect(
    () =>
      this.actions$.pipe(
        ofType(EntityEspeciesCertificablesUpdateSuccess),
        tap(() =>
          this.notificationService.success(
            'EntityEspeciesCertificables actualizado correctamente.'
          )
        )
      ),
    { dispatch: false }
  );

  updateFailure = createEffect(
    () =>
      this.actions$.pipe(
        ofType(EntityEspeciesCertificablesUpdateFailure),
        tap(() =>
          this.notificationService.error('Error al actualizar EntityEspeciesCertificables.')
        )
      ),
    { dispatch: false }
  );

  deleteSuccess = createEffect(
    () =>
      this.actions$.pipe(
        ofType(EntityEspeciesCertificablesDeleteSuccess),
        tap(() =>
          this.notificationService.success(
            'EntityEspeciesCertificables eliminado correctamente.'
          )
        )
      ),
    { dispatch: false }
  );

  deleteFailure = createEffect(
    () =>
      this.actions$.pipe(
        ofType(EntityEspeciesCertificablesDeleteFailure),
        tap(() =>
          this.notificationService.error('Error al eliminar EntityEspeciesCertificables.')
        )
      ),
    { dispatch: false }
  );
}
